// this folder contains the network requests for operations against our firestore
// databases

// collection names
export const PaxCheckinCollection = "pax-checkins"
export const DashboardAcccountsCollection = "admin-account"